import { FunctionComponent } from "react";
import { Marker } from "@vis.gl/react-google-maps";
import { useAppSelector } from "@store/store";
import { selectUserLocation } from "@store/location/locationReducer";

const UserLocationPin: FunctionComponent = () => {
  const userLocation = useAppSelector(selectUserLocation);

  if (!userLocation) {
    return null;
  }

  return (
    <Marker
      position={{
        lat: userLocation.coordinates.latitude,
        lng: userLocation.coordinates.longitude,
      }}
      icon={{
        url: "/images/icons/current-user-location.svg",
        scaledSize: new window.google.maps.Size(20, 20),
      }}
    />
  );
};

export { UserLocationPin };
